import type { ReviewDocument } from "../../hooks/use-review-documents";
import dayjs from "dayjs";

export type ReviewDocumentRow = ReviewDocument & {
  authorName: string;
};

export type ReviewDocumentTableContext = {
  canDelete: boolean;
  onDownload: (document: ReviewDocument) => void;
  onDelete: (document: ReviewDocument) => void;
};

export const getFileExtension = (fileName: string): string => {
  const parts = fileName.split(".");
  return parts.length > 1 ? (parts.at(-1) ?? "") : "";
};

export const formatUploadDate = (value: string): string => (value ? dayjs(value).format("DD.MM.YYYY, HH:mm") : "—");
